<template>  
  <div class="main alarmshow">
    <div class="asCont">
      <div class="alItem" style="flex-shrink: 0;">
        <div class="alsTit">设置预警值</div>
        <div class="flexItem flexItem1">
          <div class="cont">
            <div class="asli">
              <span>预警功率值</span><p><b>50</b>KW</p>
            </div>
            <div class="asli">
              <span>预警电流值</span><p><b>50</b>A</p>
            </div>
          </div>
          <el-button class="addAlarm" icon="el-icon-plus" @click="dialogFormVisible = true">预警设置</el-button>
        </div>
      </div>
      <div class="alItem" style="flex-grow: 1;">
        <div class="alsTit">超出预警值的水表</div>
        <div class="flexItem flexItem2">
          <div class="alsli">
            <div class="liName"><h3>小会议室水表</h3><span>水表名称</span></div>
            <div class="liTip"><h3>51KW</h3><span>功率</span></div>
            <div class="liTip"><h3>50A</h3><span>水流</span></div>
          </div>
          <div class="alsli">
            <div class="liName"><h3>小会议室水表</h3><span>水表名称</span></div>
            <div class="liTip"><h3>52KW</h3><span>功率</span></div>
            <div class="liTip"><h3>50A</h3><span>水流</span></div>
          </div>
          <div class="alsli">
            <div class="liName"><h3>小会议室水表</h3><span>水表名称</span></div>
            <div class="liTip"><h3>53KW</h3><span>功率</span></div>
            <div class="liTip"><h3>50A</h3><span>水流</span></div>
          </div>
          <div class="alsli">
            <div class="liName"><h3>小会议室水表</h3><span>水表名称</span></div>
            <div class="liTip"><h3>54KW</h3><span>功率</span></div>
            <div class="liTip"><h3>50A</h3><span>水流</span></div>
          </div>
        </div>
      </div>
    </div>
    
    <!--预警设置弹框-->
    <el-dialog title="预警设置"  :visible.sync="dialogFormVisible">
      <div>
        <!-- <div class="content"> -->
          <el-form ref="form" :model="alarmInfo" label-width="100px">
            <el-form-item label="功率预警值">
              <el-input v-model="alarmInfo.alarmPower"></el-input>
            </el-form-item>
            <el-form-item label="电流预警值">
              <el-input v-model="alarmInfo.alarmAmpere"></el-input>
            </el-form-item>
            <el-form-item label="预警手机号">
              <div class="inputDeposit clearfix" v-for="(item, index) in alarmInfo.alarmPeople" :key="index">
                <div class="alarmPhone">
                  <el-input  v-model="alarmInfo.alarmPeople[index]"></el-input>
                </div>
                <div class="editIcon">
                  <svg class="icon" aria-hidden="true" @click="deletePhone(index)">
                    <use xlink:href="#icon-delete-f73f44"></use>
                  </svg>
                </div>
              </div>
              <div class="inputDeposit clearfix" >
                <div class="alarmPhone">
                  <el-input  v-model="alarmInfo.addPhone"></el-input>
                </div>
                <div class="editIcon">
                  <svg class="icon" aria-hidden="true" @click="addAlarmPhone()">
                    <use xlink:href="#icon-add1"></use>
                  </svg>
                </div>
              </div>
            </el-form-item>
          </el-form>
          
        <!-- </div> -->
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addAlarmSetting">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import * as powerControl from "../../../../../static/js/powerControl.js"

  export default {
    name: 'AlarmShow',
    data() {
      return {
        buildingID: '001',
        alramList: {
            power: [
              {
                eMeterID:'S15716433',
                eMeterPower:50
              }
            ],
            ampere: [
              {
                eMeterID:'S15716433',
                eMeterAmpere:50
              }
            ]
        },
        alarmInfo:{
          alarmPower: 0,
          alarmAmpere: 0,
          alarmPeople: [],
          addPhone:'',
        },
        dialogFormVisible:false,
      }
    },
    mounted: async function(){
      this.buildingID = this.$store.state.buildingID;
      let alarmInfoList = await powerControl.getAlarmInfo(this.buildingID);
      alarmInfoList = alarmInfoList.body.alarmInfo;
      if(alarmInfoList==undefined){
        return
      }else{
        this.alarmInfo = alarmInfoList;
      }
    },
    created: async function () {
      let alarmInfoOld = await powerControl.getOverAlarmWatch(this.buildingID);
      this.alramList = alarmInfoOld.body;
    },
    methods: {
      async modifyGroupName() {
        // console.log('修改组名称');
      },
      // 增加报警设置
      async addAlarmSetting() {
        this.dialogFormVisible = false;
        this.alarmInfo.alarmPeople.push(this.alarmInfo.addPhone);
        // console.log('alarmInfo: ',this.alarmInfo);
        await powerControl.modifyAlarmInfo(this.buildingID, this.alarmInfo);
        this.alarmInfo.addPhone = '';
      },
      // 删除电话
      deletePhone(index) {
        this.alarmInfo.alarmPeople.splice(index, 1);
      },
      // 添加电话
      addAlarmPhone() {
        this.alarmInfo.alarmPeople.push(this.alarmInfo.addPhone);
        this.alarmInfo.addPhone = '';
      }
    },
    watch: {
      // 监听vuex的值变化
      "$store.state.buildingID":async function(newVal, oldVal) {
        this.buildingID = newVal;
        let alarmInfoOld = await powerControl.getOverAlarmWatch(this.buildingID);
        this.alramList = alarmInfo.body;
        let alarmInfoList =await powerControl.getAlarmInfo(this.buildingID);
        alarmInfoList = alarmInfoList.body.alarmInfo;
        this.alarmInfo = alarmInfoList;
      }
    },
    props: []
  }
</script>

<style lang="scss" scoped>
.alarmshow {
  margin-top: 20px; 
  .asCont{
    display: flex;
    .flexItem{
      background: #fff;
      box-shadow: 0 6px 7px 5px rgba(7,0,2,.06);
      padding: 15px;
      box-sizing: border-box;
      .addAlarm{
        margin: 19px 0 11px;
        padding: 10px 34px;
        font-size: 16px;
        color: #fff;
        border-radius: 18.5px;
        background-color: #5c75f3;
      }
      &.flexItem2{
        overflow: auto;
        height: 210px;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        padding: 3.5px 15px;
        align-content:flex-start;
        .alsli{
          background-color: #f8f9fe;
          margin: 8px 85px 8px 0;
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 220px;
          padding: 6px 13px;
          box-sizing: border-box;
          font-size: 10px;
          color: #aeb8ca;
          h3{
            font-size: 12px;
            color: #333;
            padding-bottom: 6px;
          }
          .liTip h3{
            color: #f84a4a;
          }
        }
      }
      &.flexItem1{
        width: 300px;
        margin-right: 15px;
        text-align: center;
        .cont{
          background-color: #f8f9fe;
          border-radius: 10px;
          height: 112px; 
          display: flex;
          align-items: center;
          justify-content: center;
          .asli{
            text-align: left;
            width: 50%;
            padding-left: 30px;
            box-sizing: border-box;
            font-size: 16px;
            color: #666;
            p{
              font-size: 18px;
              color: #a7b2c5;
              margin-top: 10px;
              b{
                font-size: 24px;
                color: #3c4a79;
              }
            }
          }
        }
      }
    }
    .alsTit{
      font-size: 14px;
      color: #999;
      line-height: 30px;
      padding: 0 15px;
    }
  }
  .alarmTitle {
    font-weight: bold;
  }
  .powerAlarmArea{
    width:100%;
    display: flex;
    flex-wrap: wrap;
  }
  .alarmInfo {
    width:220px;
    height:50px;
    border-radius: 5px;
    border:1px solid black;
    margin: 10px;
  }
  .eMeterName {
    margin-top: 15px;
    margin-left: 10px;
    float: left;
  }
  .powerValue {
    color: red;
    margin-top: 15px;
    margin-left: 10px;
    margin-right: 10px;
    float: right;
  }
  .explain {
    width:200px; 
    float:left; 
  }
  .inputDeposit {
    width: 300px;
  }
  .alarmPeopleTitle {
    float: left;
  }
  .alarmPeopleList {
    float: left;
    margin-left: 3%;
  }
  .alarmPhone {
    float: left;
    margin-bottom: 3%;
  }
  .editIcon {
    float: left;
    margin-left: 3%;
  }
  .icon {
    width: 1.2em; 
    height: 1.2em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
  .clearfix::after {
    content: ''; 
    display: block; 
    clear: both;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CWaterManage/BuildingInfo/AlarmShow.vue